<template>
  <transition name="fade">
    <div class="level3-landingpage-container">
      <div class="lv3-title-text">Tambah {{ label }}</div>
      <div class="lv3-edit-form" style="overflow-y: auto !important">
        <div class="edit-form-wrapper">
          <div>Nama {{ label }}</div>
          <input class="lv3-input-text" type="text" v-model="company_name"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Nama Kontak<span class="text-ast">*</span></div>
          <input class="lv3-input-text" type="text" v-model="contact_name"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Posisi</div>
          <input class="lv3-input-text" type="text" v-model="position"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Telepon<span class="text-ast">*</span></div>
          <div class="vendor-form">
            <!-- <input class="lv3-input-text" type="text" v-model="phoneDirektur" /> -->
            <div class="phone-add">
              <the-mask class="phone-add__phone" :mask="[
                `+${$store.state.k3lStore.phone_code} ####################`,
              ]" v-model="phone" />
            </div>
          </div>
        </div>
        <div class="edit-form-wrapper">
          <div>Email<span class="text-ast">*</span></div>
          <input class="lv3-input-text" type="text" v-model="email"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitForm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import { api_lp } from '../../services/config'
export default {
  props: [
    'label',
    'mutationName',
    'arrayMutation',
    'modalName',
    'modelName',
    'storeName',
  ],
  data() {
    return {
      // company_name: '',
      //   contact_name: '',
      //   position: '',
      //   phone: '',
      //   email: '',
    }
  },

  computed: {
    company_name: {
      get() {
        return this.$store.state[this.storeName].companies_name
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'companies_name',
          value: newValue,
        })
      },
    },
    contact_name: {
      get() {
        return this.$store.state[this.storeName].companies_contact
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'companies_contact',
          value: newValue,
        })
      },
    },
    position: {
      get() {
        return this.$store.state[this.storeName].companies_position
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'companies_position',
          value: newValue,
        })
      },
    },
    phone: {
      get() {
        return this.$store.state[this.storeName].companies_phone
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'companies_phone',
          value: newValue,
        })
      },
    },
    email: {
      get() {
        return this.$store.state[this.storeName].companies_email
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'companies_email',
          value: newValue,
        })
      },
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.company_name, `Nama ${this.label}`],
        [this.contact_name, 'Nama kontak'],
        [this.phone, 'Telepon'],
        [this.isEmailValid(this.email), 'Email'],
      ]

      return this.multiConditions(arr)
    },
    async submitForm() {
      if (this.checkForm()) {
        let dataForm = {
          // id: this.$store.state[this.storeName]['companies_index'] + 1,
          request_id: this.$store.state[this.storeName]['request_id'],
          company_name: this.company_name,
          contact_name: this.contact_name,
          position: this.position,
          phone: this.phone,
          email: this.email,
        }

        this.pushData(dataForm)

        // if (this.$store.state[this.storeName]['companies_add']) {
        //   await this.$store.commit(this.arrayMutation, {
        //     name: this.modelName,
        //     value: dataForm,
        //     operation: 'add',
        //   })
        //   await this.$store.commit(this.mutationName, {
        //     name: this.modalName,
        //     value: false,
        //   })
        // } else if (this.$store.state[this.storeName]['companies_edit']) {
        //   dataForm.id = this.$store.state[this.storeName]['companies_id']
        //   await this.$store.commit(this.arrayMutation, {
        //     name: this.modelName,
        //     value: dataForm,
        //     operation: 'edit',
        //   })
        //   await this.$store.commit(this.mutationName, {
        //     name: this.modalName,
        //     value: false,
        //   })
        // }
      } else {
        // do nothing
      }
    },
    async pushData(form) {
      try {
        let url = `${api_lp}/api/v1/vendor/child`
        let method = 'POST'

        if (this.modelName == 'parent_companies') {
          url = `${api_lp}/api/v1/vendor/parent`
          if (this.$store.state.k3lStore.companies_edit) {
            method = 'PUT'
            url = `${api_lp}/api/v1/vendor/parent/${this.$store.state.k3lStore.companies_id}`
          }
        } else {
          if (this.$store.state.k3lStore.companies_edit) {
            method = 'PUT'
            url = `${api_lp}/api/v1/vendor/child/${this.$store.state.k3lStore.companies_id}`
          }
        }

        const { data } = await axios({
          method,
          url,
          data: form,
        })

        if (data && data.status == 'success') {


          await this.$store.commit(this.mutationName, {
            name: this.modelName,
            value: data.data,
          })

          this.$store.commit(this.mutationName, {
            name: 'companies_name',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'companies_contact',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'companies_position',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'companies_phone',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'companies_email',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'companies_edit',
            value: false,
          })

          this.closeModal()
        }
      } catch (error) {

      }
    },
    closeModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
